import { Button, Card, Elevation, H3, Tag } from "@blueprintjs/core";
import { setCurrentModel } from "controllers/common/action";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "./ProductionCard.scss";
import ModelTypeTag from "components/ModelTypeTag";
import Markdown from "components/Markdown";

interface ProductionProps {
  name: string; // a.k.a. ID
  title: string;
  label: string; // abbreviation
  brief: any;
  link: string;
  buttonText: string;
  keywords?: Array<string>;
}

export default function ProductionCard(production: ProductionProps) {
  const dispatch = useDispatch();
  const handleClick = () => dispatch(setCurrentModel({ modelName: "", modelType: production.name }));

  return (
    <Link className="production" to={production.link}>
      <Card
        className="production-card"
        interactive={true}
        onClick={production.link.includes("dashboard") ? handleClick : undefined}
        elevation={Elevation.TWO}
      >
        <div className="production__title-line">
          <H3>
            {production.title}
          </H3>
          {production?.name && <ModelTypeTag modelType={production.name} hideTooltip />}
        </div>
        <div className="production__keywords">
          {production.keywords
            ? production.keywords?.map((keyword) => (
              <Tag className="keyword-tag" key={production.title + keyword}>
                {keyword}
              </Tag>
            ))
            : ""}
        </div>

        <Markdown markdown={production.brief} />

        <Button
          className="production__button"
          minimal
          intent="primary"
          text={production.buttonText}
          rightIcon="arrow-right"
          onClick={production.link.includes("dashboard") ? handleClick : undefined}
        />
      </Card>
    </Link>
  );
}
